import React, { useState, useEffect, useRef } from 'react';
import { Col, Container } from 'react-bootstrap';
import Message from './message.jsx'
import { sendRequest } from "./token_util";
import Cookie from 'universal-cookie';
import { saveDocxArray } from "./save.jsx";

function TranslateWithCol({ height, message, timeStamp, speaker = 'Unknown', speechLanguage
                        , language, alias, saveTranslation, onSaved }) {
  const [translateMessages, setTranslateMessages] = useState([]); // 将初始值设置为空数组
  const messagesEndRef = useRef(null);
  const [requestQueue, setRequestQueue] = useState([]); // 新增状态：请求队列
  const [processing, setProcessing] = useState(false); // 新增状态：是否正在处理请求
  const [newChunk, setNewChunk] = useState(null); // 新增状态：新接收到的数据块

  const cookie = new Cookie();
  const loginInfo = cookie.get('login-info');

  useEffect(() => {
    if (saveTranslation && translateMessages.length > 0) {
        // 在这里执行保存操作
        const messageJson = JSON.stringify(translateMessages)

        const textContent = translateMessages.map((item) => {
          const { user, timestamp, message } = item;
          return `${timestamp}\n${user}：\n${message}\n\n`;
        });

        saveDocxArray("speech", textContent);
    
        // 保存操作完成后，调用 onSaved 回调以将状态重置为 false
        if (onSaved) {
            onSaved();
        }
    }
  }, [saveTranslation, onSaved]);

  // 解析返回的 chunk
  const handleChunkReceived = (chunk) => {  
    updateLastMessage(chunk);
  };

  const updateLastMessage = (newMessage) => {
    setTranslateMessages((prevMessages) => {
      return prevMessages.map((msg, index) => {
        if (index === prevMessages.length - 1) {
          return {
            ...msg,
            message: msg.message + newMessage,
          };
        }
        return msg;
      });
    });
  };

  // 添加新消息的函数
  const addMessage = (newMessage, newUser) => {
    setTranslateMessages([
      ...translateMessages,
      {
        message: newMessage,
        timestamp: timeStamp,
        user: newUser,
      },
    ]);
  };

  useEffect(() => {
    if (message) {      
      // 将新请求添加到队列中
      setRequestQueue((prevQueue) => [...prevQueue, { language, message }]);
    }
  }, [message]);

  useEffect(() => {
    // 如果队列中有请求，处理第一个请求
    if (requestQueue.length > 0 && !processing) {
      const fetchData = async () => {
        setProcessing(true);
        const { language, message } = requestQueue[0];
        let uid = "";
        if (loginInfo !== undefined) {
          uid = loginInfo['uid'];
        }
        console.log("translate: ", { language, message, uid });

        // 在处理请求之前添加新的消息项
        addMessage('', speaker);
        
        // 检查 message 是否有内容
        if (message.trim().length > 0) {
          // 如果语种一样则直接复制，不一样则传递给 GPT 翻译
          console.log(speechLanguage, alias);
          if (speechLanguage === alias) {
            updateLastMessage(message);
          } else {             
            await sendRequest("/translate", { speechLanguage, language, message, uid }, handleChunkReceived);
          }
        }

        // 请求完成后，从队列中移除
        setRequestQueue((prevQueue) => prevQueue.slice(1));
        setProcessing(false);
      };

      fetchData();
    }
  }, [requestQueue, processing]); // 当请求队列发生变化时，处理队列中的请求

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
    }
  }, [translateMessages]);

  // 新增 useEffect，当 newChunk 发生变化时，调用 updateLastMessage 函数
  useEffect(() => {
    if (newChunk !== null) {
      updateLastMessage(newChunk);
      setNewChunk(null); // 重置 newChunk 以避免重复执行
    }
  }, [newChunk]);

  return (
    <Col style={{ height: height }}>
      <main className="main is-visible" data-dropzone-area="">
        <Container className='h-100'>
          <div className='d-flex flex-column h-100 position-relative'>
            <div className="chat-body flex-1 h-100">
              <div className="chat-body-inner" ref={messagesEndRef}>
                <div className="py-6 py-lg-12">
                  {translateMessages.map((msg, index) => (
                    <Message
                      key={index}
                      message={msg.message}
                      timestamp={msg.timestamp}
                      user={msg.user}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </main>
    </Col>
  );
}

export default TranslateWithCol;